import { makeStyles } from 'tss-react/mui';
const styles = (theme) => ({
    formContainer: {
        width: '100%',
    },
    label: {
        marginBottom: '15px',
        display: 'block',
        p: {
            color: 'rgb(226,224,224)',
            paddingBottom: '8px',
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '17px',
            textShadow: 'rgba(0,0,0,0.04), 1px 1px 1px',
        },
    },
    selectMenu: {
        backgroundColor: theme.palette.grey[900],
        height: theme.spacing(8),
        fontSize: '14px',
        color: 'white',
    },
    button: {
        padding: '10px 24px 10px 24px',
        width: '100%',
        height: '38px',
        fontSize: '14px',
        marginBottom: '9px',
    },
});
export const useStyles = makeStyles()(styles);
//# sourceMappingURL=sharedSelector.styles.js.map